import Index from "../../modules/crm/Index.vue";
import List from "../../modules/crm/clients/List.vue";
import Overview from "../../modules/crm/clients/Client.vue";
import Reporting from "../../modules/crm/reporting/Index.vue";

const routes = [
    {
        path: '/conseillers', component: Index, children: [
            { path: 'crm', component: List },
            { path: 'crm/:id', component: Overview },
            { path: 'reporting', component: Reporting },
        ]
    },
];

export default routes;